var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { cleanInteger, cleanDecimal } from '@/common/utils/numberUtilities';
var NumericSanitizeable = /** @class */ (function (_super) {
    __extends(NumericSanitizeable, _super);
    function NumericSanitizeable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumericSanitizeable.prototype.commonSanitize = function (event) {
        // Add keycode here if some key seems to do nothing when pressed with focus on numeric field
        if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0',
            '.', ',', '-', "Delete", "Backspace", "ArrowLeft", "ArrowRight", "Home", "End", "Esc",
            "Tab", "F5", "F12"].indexOf(event.key) == -1) {
            event.preventDefault();
        }
    };
    NumericSanitizeable.prototype.sanitize = function (event) {
        this.commonSanitize(event);
        if (['.', ','].indexOf(event.key) >= 0) {
            event.preventDefault();
        }
    };
    NumericSanitizeable.prototype.sanitizePositive = function (event) {
        this.commonSanitize(event);
        if (['-', '.', ','].indexOf(event.key) >= 0) {
            event.preventDefault();
        }
    };
    NumericSanitizeable.prototype.sanitizeDecimal = function (event) {
        this.commonSanitize(event);
    };
    NumericSanitizeable.prototype.sanitizePositiveDecimal = function (event) {
        this.commonSanitize(event);
        if (['-'].indexOf(event.key) >= 0) {
            event.preventDefault();
        }
    };
    NumericSanitizeable.prototype.cleanInt = function (val, positive) {
        if (positive === void 0) { positive = true; }
        return cleanInteger(val, positive);
    };
    NumericSanitizeable.prototype.cleanDec = function (val, positive, decimals) {
        if (positive === void 0) { positive = true; }
        if (decimals === void 0) { decimals = 2; }
        return cleanDecimal(val, positive, decimals);
    };
    NumericSanitizeable = __decorate([
        Component
    ], NumericSanitizeable);
    return NumericSanitizeable;
}(Vue));
export { NumericSanitizeable };
